<template>
   <div class="container">
  <div class="quesbox">
    <div class="ques">
      <span>问</span>{{quesTitle}}
    </div>
    <div class="ans" v-html="quesContent">
    </div>
  </div>
</div>
</template>

<script>
import utils from '../assets/js/utils'
export default {
  name: 'answer',
  data () {
    return{
      list: [],
      queLst: [],
      quesTitle: '',
      quesContent: '',
      id:utils.getUrlStr('id')
    }
  },
  mounted() {
    
    const formData = new FormData()
    formData.append('h5Type', utils.getUrlStr('type'))
    formData.append('id', utils.getUrlStr('id'))
     this.$http({
        method: 'post',
        url: '/api/mine/html5List',
        data: formData
     }).then((res)=>{
      if(res.data.status === 200){
        console.log(res)
        this.quesTitle = res.data.data.appHtml5[0].h5Title
        this.quesContent = res.data.data.appHtml5[0].h5Content
      }else{

        alert(res.data.msg)
        }
      })
  },
  methods:{
    answer(item) {
      this.ansShow = true
      this.quesTitle = item.h5Title
      this.quesContent = item.h5Content
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.container{ background: #f7f7f7;

.quesbox{padding: 0.375rem 0.825rem 1rem ;  background: #fff;overflow:hidden; }
.ques{ color: #333; font-size: 0.8rem; line-height: 1.35rem;}
.ques span{width: 0.7rem; height: 0.7rem;line-height: 0.7rem; text-align: center; background: #f42f19; border-radius: 50%; color:#fff; font-size: 0.5rem; float: left; margin:0.3rem 0.25rem 0 0;}
.ans {
  margin-top: .5rem; font-size: 0.7rem; line-height: 1.4rem;
  img{max-width: 100%;}     
}  


}


</style>



// WEBPACK FOOTER //
// src/components/answer.vue